var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPixels = function SvgPixels(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 76,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M52-1H39v13h13zM65-1H52v13h13zM65 64H52v13h13zM78 64H65v13h13zM39 64H26v13h13zM52 51H39v13h13zM65 51H52v13h13zM39 38H26v13h13zM26 38H13v13h13zM13 25H0v13h13zM65 38H52v13h13zM78 38H65v13h13zM65 12H52v13h13zM78 12H65v13h13zM78 25H65v13h13zM52 25H39v13h13zM39 12H26v13h13z"
  })));
};
export default SvgPixels;